import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.14645 3.14645C3.24021 3.05268 3.36739 3 3.5 3H4.5C4.63261 3 4.75979 3.05268 4.85355 3.14645C4.94732 3.24021 5 3.36739 5 3.5V14H17.67L14.22 10.56C14.1734 10.5144 14.1364 10.4599 14.1112 10.3998C14.0859 10.3397 14.0729 10.2752 14.0729 10.21C14.0729 10.1448 14.0859 10.0803 14.1112 10.0202C14.1364 9.96008 14.1734 9.90562 14.22 9.86L14.93 9.15C14.9765 9.10314 15.0318 9.06594 15.0927 9.04055C15.1536 9.01517 15.219 9.0021 15.285 9.0021C15.351 9.0021 15.4164 9.01517 15.4773 9.04055C15.5382 9.06594 15.5935 9.10314 15.64 9.15L20.78 14.28C20.9189 14.4217 20.9977 14.6116 21 14.81V15.19C20.9998 15.3888 20.9207 15.5795 20.78 15.72L15.64 20.85C15.5935 20.8969 15.5382 20.9341 15.4773 20.9594C15.4164 20.9848 15.351 20.9979 15.285 20.9979C15.219 20.9979 15.1536 20.9848 15.0927 20.9594C15.0318 20.9341 14.9765 20.8969 14.93 20.85L14.22 20.15C14.1731 20.1035 14.1359 20.0482 14.1106 19.9873C14.0852 19.9264 14.0721 19.861 14.0721 19.795C14.0721 19.729 14.0852 19.6636 14.1106 19.6027C14.1359 19.5418 14.1731 19.4865 14.22 19.44L17.67 16H5C4.46957 16 3.96086 15.7893 3.58579 15.4142C3.21071 15.0391 3 14.5304 3 14V3.5C3 3.36739 3.05268 3.24021 3.14645 3.14645Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgSubdirectoryRightOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgSubdirectoryRightOutline;
